import clsx from "clsx";
import { GameStatePlayerDto } from "dtos/frankenstories/GameStatePlayerDto";
import { FrankenstoryStoryItemDto } from "dtos/frankenstories/FrankenstoryStoryItemDto";
import { Fragment, useEffect, useState } from "react";
import { ReplyDisplay } from "components/game/ReplyDisplay";
import { StoryDetails } from "components/game/StoryDetails";
import { PlayerDictionary } from "components/game/CompletedStory";
import { CompletedGamePlayerStateResult } from "results/frankenstories/CompletedGamePlayerStateResult";
import { RouteLink } from "Routes";

const StoryItem = (props: {
    reply: FrankenstoryStoryItemDto;
    selectedPlayer?: GameStatePlayerDto;
    showDetails: boolean;
    getVoteCount: (replyId: number) => number;
    showCharacters?: boolean;
    playerName: string;
    playerState?: CompletedGamePlayerStateResult;
    groupId?: number;
}) => {
    const { reply, selectedPlayer, showDetails, showCharacters, getVoteCount, playerName, playerState, groupId } =
        props;

    const [shown, setShown] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShown(true);
        }, 30);
    }, []);

    return (
        <div
            className={clsx(
                "completed-story animate",
                shown ? "opacity-100" : "opacity-0",
                !showDetails && "completed-story--single",
            )}
            key={reply.id}
        >
            <div className="order-1 order-lg-0 vstack gap-2 z-1">
                {selectedPlayer && (
                    <div className="h6 text-center text-lg-start">
                        {reply.isTitleRound ? (
                            <Fragment>Title round</Fragment>
                        ) : (
                            <Fragment>Round {reply.roundNumber}</Fragment>
                        )}
                    </div>
                )}

                <ReplyDisplay
                    isWinner={reply.isWinner}
                    body={reply.body}
                    hasSticker={reply.hasSticker}
                    isPerfect={reply.isPerfect}
                    characterId={showCharacters && reply.characterId != null ? reply.characterId : undefined}
                />
            </div>

            {showDetails && (
                <StoryDetails
                    isPerfect={reply.isPerfect}
                    characterId={reply.characterId}
                    playerName={playerName}
                    reactionCount={reply.reactionCount}
                    voteCount={getVoteCount(reply.id)}
                    url={
                        (playerState?.isLeader || playerState?.isPlayer) && reply.userId && groupId
                            ? RouteLink.classesClassStudent(groupId, reply.userId)
                            : undefined
                    }
                />
            )}
        </div>
    );
};

export const StoryRepliesDisplay = (props: {
    showThread: boolean;
    selectedReplies: Array<FrankenstoryStoryItemDto>;
    showDetails: boolean;
    selectedPlayer?: GameStatePlayerDto;
    showCharacters?: boolean;
    getVoteCount: (replyId: number) => number;
    playerNames: PlayerDictionary;
    groupId?: number;
    playerState?: CompletedGamePlayerStateResult;
}) => {
    const {
        showThread,
        selectedReplies,
        selectedPlayer,
        showDetails,
        showCharacters,
        getVoteCount,
        playerNames,
        playerState,
        groupId,
    } = props;

    return (
        <div className={clsx("vstack animate", showThread && "thread", !showCharacters && "gap-4")}>
            {selectedReplies.map(reply => {
                const playerName = playerNames[reply.playerId];

                return (
                    <StoryItem
                        key={reply.id}
                        playerName={playerName}
                        reply={reply}
                        showDetails={showDetails}
                        showCharacters={showCharacters}
                        selectedPlayer={selectedPlayer}
                        getVoteCount={getVoteCount}
                        playerState={playerState}
                        groupId={groupId}
                    />
                );
            })}
        </div>
    );
};
